import React from "react";
import { Card, CardContent, CardHeader } from "./card";
import { cn } from "../../lib/utils";

export function Features({
  title,
  subtitle,
  items = [],
  className,
}) {
  return (
    <section
      className={cn(
        "relative w-full py-20 md:py-28 bg-black text-white",
        className,
      )}
    >
      <div className="absolute inset-0 pointer-events-none opacity-60 [background:radial-gradient(60%_60%_at_50%_0%,rgba(122,92,255,0.18),transparent_60%),radial-gradient(50%_50%_at_50%_100%,rgba(122,149,181,0.12),transparent_60%)]" />

      <div className="relative mx-auto max-w-6xl px-6">
        <div className="text-center">
          <h2 className="text-balance text-3xl md:text-5xl font-bold tracking-tight bg-gradient-to-br from-white via-white to-white/60 bg-clip-text text-transparent">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-4 text-base md:text-lg text-white/60 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
        </div>

        <div className="mx-auto mt-12 md:mt-16 grid max-w-sm gap-6 md:max-w-full md:grid-cols-2 lg:grid-cols-3 *:text-center">
          {items.map((item, idx) => (
            <Card
              key={idx}
              className={cn(
                "group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm",
                "transition-all duration-300 hover:-translate-y-1 hover:border-white/20 hover:bg-white/[0.06]",
                "shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6)]",
              )}
            >
              <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100 [background:radial-gradient(40%_60%_at_50%_0%,rgba(122,92,255,0.25),transparent_70%)]" />

              <CardHeader className="pb-3">
                <CardDecorator>
                  {item.icon}
                </CardDecorator>
                <h3 className="mt-6 text-lg font-semibold text-white">
                  {item.title}
                  {item.comingSoon && (
                    <span className="ml-2 inline-block align-middle text-[10px] font-medium uppercase tracking-wider text-white/70 border border-white/20 rounded-full px-2 py-0.5">
                      Coming soon
                    </span>
                  )}
                </h3>
              </CardHeader>

              <CardContent>
                <p className="text-sm text-white/76 leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

const CardDecorator = ({ children }) => (
  <div
    aria-hidden
    className="relative mx-auto size-32 [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)]"
  >
    <div className="absolute inset-0 [--border:rgba(255,255,255,0.9)] bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:24px_24px] opacity-10" />
    <div className="absolute inset-0 m-auto flex size-12 items-center justify-center rounded-md border border-white/20 bg-white/[0.04] text-white shadow-[inset_0_0_24px_rgba(255,255,255,0.06)]">
      {children}
    </div>
  </div>
);

export default Features;
